jQuery.noConflict();
(($) => {
    const navbar = $('.navbar')
    const bttlink = $('.bttlink')
    const adjustBodyPadding = () => {
        var navbarheight = navbar.outerHeight();
        $('a.anchor').css('top', -navbarheight+2);
        $('header').css('margin-top', navbarheight);
    };

    bttlink.hide();
    $(window).resize(() => adjustBodyPadding());
    $(window).on('scroll', () => {
      navbar.offset().top > navbar.outerHeight()*2 ? navbar.addClass('navbar-small') : navbar.removeClass('navbar-small');
      $(document).scrollTop() > $(window).height()/2 ? bttlink.fadeIn() : bttlink.fadeOut();
    })
    $('body').on('mouseup', ()=>{
        let c = bootstrap.Collapse.getInstance('.navbar-collapse');
        c ? c.hide() : false;
    });

    const init = () => {
        adjustBodyPadding();
    };

    init();

    // rewrite urls with <wbr>-tags
    $('.typography a').each((iterator, elem) => {
        let url = ($(elem).text());
        let formatted = url.replace(/(?<before>[/])/giu, '­$1');
        $(elem).text(formatted);
    });
})(jQuery);
